import { apiGet, apiPost } from 'helpers/ApiHelper';
import Auth from 'j-toker';
import { showFailure } from 'actions/notificationActions';
import { GET_AMENITY_BOOKINGS, GET_NOTICES, GET_EVENTS } from './actionTypes';

export function getResidentAmenityBookings(cotenantId, limit = 4) {
  return dispatch => {
    const url = `${Auth.getApiUrl()}/bookings/resident/${cotenantId}?limit=${limit}`;

    dispatch({
      type: GET_AMENITY_BOOKINGS,
      payload: apiGet(url).catch(err => {
        dispatch(showFailure(err));
      }),
    });
  };
}

export function getResidentNotices(cotenantId, propertyId, limit = 4) {
  return dispatch => {
    const url = `${Auth.getApiUrl()}/landlords/filtered_notices?limit=${limit}`;

    dispatch({
      type: GET_NOTICES,
      payload: apiPost(url, {
        cotenant_id: cotenantId,
        property_ids: [propertyId],
      }).catch(err => {
        dispatch(showFailure(err));
      }),
    });
  };
}

export function getResidentEvents(cotenantId, limit = 4) {
  return dispatch => {
    const url = `${Auth.getApiUrl()}/landlords/tenants/${cotenantId}/rsvped_events?limit=${limit}`;

    dispatch({
      type: GET_EVENTS,
      payload: apiGet(url).catch(err => {
        dispatch(showFailure(err));
      }),
    });
  };
}
